import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { AuthTokens, authStorage } from '../utils/authStorage';

const DEFAULT_SDK_PRODUCT_ID = 10005;

const authApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

authApi.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    sdkProductId: DEFAULT_SDK_PRODUCT_ID,
  };
  return config;
});

export interface CaptchaResponse {
  captchaId: string;
  captchaImage: string;
}

export interface LoginParams {
  loginName: string;
  password: string;
  captchaId: string;
  captchaCode: string;
}

export interface ChangePasswordParams {
  oldPassword: string;
  newPassword: string;
}

const unwrap = <T>(response: any): T => {
  const data = response.data;
  if (data && data.status !== 200 && data.status !== undefined) {
    throw new Error(data.message || '请求失败');
  }
  return data.data;
};

export const authService = {
  async getCaptcha(): Promise<CaptchaResponse> {
    const response = await authApi.get('/admin/auth/captcha');
    return unwrap<CaptchaResponse>(response);
  },

  async login(params: LoginParams): Promise<AuthTokens> {
    const response = await authApi.post('/admin/auth/login', {
      ...params,
      sdkProductId: DEFAULT_SDK_PRODUCT_ID,
    });
    const tokens = unwrap<AuthTokens>(response);
    authStorage.set(tokens);
    return tokens;
  },

  async refresh(refreshToken: string): Promise<AuthTokens> {
    const response = await authApi.post('/admin/auth/refresh', { refreshToken });
    const tokens = unwrap<AuthTokens>(response);
    authStorage.set(tokens);
    return tokens;
  },

  async changePassword(params: ChangePasswordParams): Promise<void> {
    const tokens = authStorage.get();
    const response = await authApi.post('/admin/auth/changePassword', params, {
      headers: tokens?.accessToken ? {
        Authorization: `Bearer ${tokens.accessToken}`,
      } : undefined,
    });
    unwrap(response);
  },

  logout() {
    authStorage.clear();
  },
};
